import styled, { css } from 'styled-components';

export const ModalContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    height: calc(100vh - 102px);
    max-width: 100vw;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 20px;
    }
 `}
`;

export const ModalTitleContainer = styled.div`
  ${({ theme }) => css`
  align-items: center;
  border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium}; 
  display: flex;
  justify-content: space-between;
  padding: 24px 48px;

  @media (max-width: ${theme.v2.breakpoints.md}) {
    padding: 0;
  }

 `} 
`;

export const ModalTitle = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    flex: 1;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 150%;
    margin: 0;
    padding-right: 112px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      padding-right: 0;
    }
  `}
`;

export const Logo = styled.img``;

export const ModalSubtitle = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 130%;
    margin: 0;
    margin-top: 55px;
    text-align: center;

    strong {
      font-weight: ${theme.v2.font.weights.bold};
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
      margin-top: 4px;

      svg {
        margin: 0 50%;
      }
    }
  `}
`;

export const ModalDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 150%;
    margin: 16px 0 22px 0;
    max-width: 768px;
    text-align: center;

    strong {
      font-weight: ${theme.v2.font.weights.medium};
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      margin: 8px 8px 20px 8px;
    }
  `}
`;

export const TellUsTitle = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 150%;
    margin: 0 0 24px 0;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin: 0 0 14px 0;
    }
  `}
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 672px;
  width: 100%;
`;

export const ColorCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 24px;
  max-width: 672px;
  width: 100%;

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 16px;
  }
`;

export const ColorCard = styled.div`
  ${({ background }) => css`
    align-items: center;
    background: ${background};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 2px;
    height: 94px;
    justify-content: center;
    padding: 16px;
    position: relative;
    width: 156px;
  `}
`;

export const ColorName = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 150%;
    margin: 0;
  `}
`;

export const ColorDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.highPure};
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 150%;
    margin: 0;
    text-align: center;
  `}
`;

export const ChooseColor = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 150%;
    margin: 0;
    margin-top: 30px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
      margin-top: 22px;
      max-width: 320px;
    }
  `}
`;

export const Actions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 48px 0;
  padding-bottom: 80px;
  max-width: 672px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 8px;
    margin: 32px 0;
    width: auto;
  }

`;

export const ErrorMessage = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.feedback.problemMedium};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 150%;
    margin: 46px 0 -16px 0;
    text-align: center;
  `}
`;

export const SelectedColorFeedback = styled.div`
    align-items: center;
    background: rgba(31, 32, 68, 0.64);
    border-radius: 8px;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    width: 100%;
`;

export const IconCheckWrapper = styled.div`
  align-items: center;
  background: #fff;
  border-radius: 50%;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;

export const LoadingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const LoadingText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 150%;
    margin: 0;
    text-align: center;
  `}
`;
